"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var chroma_js_1 = __importDefault(require("chroma-js"));
var darken = function (color, ratio) { return chroma_js_1.default.mix(color, '#000', ratio).hex(); };
var inputColors = function (completeGlobal, gray, variant) { return ({
    background: completeGlobal.contentBackground,
    backgroundDisabled: darken(completeGlobal.contentBackground, 0.25),
    border: variant.light.default,
    borderFocus: variant.light.info,
    boxShadow: "inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px ".concat((0, chroma_js_1.default)(variant.light.info).alpha(0.4).css()),
    color: completeGlobal.textDefault,
    colorDisabled: gray[60],
    placeholder: gray[60],
}); };
exports.default = inputColors;
